import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "error-msg-wrap" }
const _hoisted_2 = {
  key: 0,
  class: "form-wrapper slide-up",
  style: {"width":"500px"}
}
const _hoisted_3 = { class: "form-close" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { style: {"margin-bottom":"15px"} }
const _hoisted_6 = { class: "my-checklists-label" }
const _hoisted_7 = {
  key: 0,
  class: "who-can-view-list",
  style: {"margin-bottom":"20px"}
}
const _hoisted_8 = { class: "my-checklists-label" }
const _hoisted_9 = {
  key: 1,
  class: "who-can-view-list",
  style: {"margin-bottom":"20px"}
}
const _hoisted_10 = { class: "my-checklists-label" }
const _hoisted_11 = {
  key: 2,
  class: "who-can-view-list"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isLoaded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("button", {
              type: "button",
              class: "form-close-x",
              title: "Close",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
            }, "×")
          ]),
          _cache[5] || (_cache[5] = _createElementVNode("h3", null, "Who Can View", -1)),
          (_ctx.isCompany)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _cache[1] || (_cache[1] = _createTextVNode(" Everyone in the company can see and update the ", -1)),
                _createElementVNode("b", null, _toDisplayString(_ctx.teamLabel(_ctx.team)), 1),
                _cache[2] || (_cache[2] = _createTextVNode(" scoreboard. ", -1))
              ]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("div", _hoisted_5, [
                  _cache[3] || (_cache[3] = _createTextVNode(" Anyone whose employee record is on the ", -1)),
                  _createElementVNode("b", null, _toDisplayString(_ctx.teamLabel(_ctx.team)), 1),
                  _cache[4] || (_cache[4] = _createTextVNode(" team can see and update this scoreboard. Teams are set on each employee's record. ", -1))
                ]),
                _createElementVNode("div", _hoisted_6, "Standard users (" + _toDisplayString(_ctx.publicUsers.length) + ")", 1),
                (_ctx.publicUsers.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.publicUsers, (u) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: u.ID
                        }, _toDisplayString(u.FirstName) + " " + _toDisplayString(u.LastName), 1))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_8, "Admins & editors (" + _toDisplayString(_ctx.users.length) + ")", 1),
                (_ctx.users.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (u) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: u.UserID
                        }, _toDisplayString(u.FirstName) + " " + _toDisplayString(u.LastName), 1))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_10, "Team Hub Admins (" + _toDisplayString(_ctx.teamHubAdmins.length) + ")", 1),
                (_ctx.teamHubAdmins.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.teamHubAdmins, (u) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: u.UserID
                        }, _toDisplayString(u.FirstName) + " " + _toDisplayString(u.LastName), 1))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
        ]))
      : _createCommentVNode("", true)
  ]))
}